import React, { useState, useEffect,useCallback, useRef } from 'react';
import "./_mySites.scss";
import IconChevron from './IconChevron';
import Button from 'react-bootstrap/Button';
import { Form, Dropdown } from 'react-bootstrap';
import { connect } from 'react-redux';
import ActionModals from './ActionModals/ActionModals';
import { useCombined } from '../../../common/base/CombinedContext';
import RequestStatusBadge from '../../../common/base/RequestStatusBadge/RequestStatusBadge';
import TablePaginationNew from '../../../common/Pagination/TablePaginationNew';
import { fetchSites, fetchApiGroups, approveRequest, denyRequest, deleteRequest } from '../../actions/sites';
import { useToast } from '../../../common/base/ToastContext';

function MySites({...props}) {
    
    const [expandedRow, setExpandedRow] = useState(null);
    const [isHashChanged, setIsHashChanged] = useState(false);
    const [hashValue, setHashValue] = useState(window.location.hash);
    const [notificationId, setNotificationId] = useState(null);
    const [sites, setSites] = useState([]);
    const [selectedSite, setSelectedSite] = useState(""); 
    const [selectedApiGroup, setSelectedApiGroup] = useState("");
    const [selectedStatus, setSelectedStatus] = useState('');   
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedRequest, setSelectedRequest] = useState(null);
    const { showLoader, hideLoader } = useCombined();
    const { showToast } = useToast();
    
    const [requestResponse, setRequestResponse] = useState({});
    const [filteredData, setFilteredData] = useState(requestResponse);   

    // TO SET BREADCRUMB FOR MY SITES PAGE
    const breadcrumbItems = [
        {
            title:"Cisco IT APIs",
            url:"/"
        },
        {
            title:"Sites Management",
            url:""
        }]
    const { setBreadcrumbItems } = useCombined()

    useEffect(() => {
        setBreadcrumbItems(breadcrumbItems);
    }, [setBreadcrumbItems]);

    // FOR FETCHING TABLE DATA - BASED ON HASH CHANGE
    useEffect(() => {
        const handleHashChange = () => {
            const hash = window.location.hash;
            const queryParams = new URLSearchParams(hash.split('?')[1]);
            const notificationId = queryParams.get('notificationId') || null;
        
            if (notificationId) {
                setNotificationId(notificationId);
            }
            setIsHashChanged(true);
            setHashValue(hash);
        };
    
        if (window.location.hash) {
            handleHashChange();
        }
        window.addEventListener('hashchange', handleHashChange);
        return () => {
            window.removeEventListener('hashchange', handleHashChange);
        };
    }, []);
    
    // -- IF HASH VALUE CHANGES, CALLS FETCHREQ FOR TABLE DATA
    useEffect(() => {
        if (isHashChanged) {
            fetchSiteRequest();
        }
    }, [hashValue, isHashChanged]);

    // FOR TABLE API
    async function fetchRequest(site) {
        showLoader("fetchRequest");
        props.dispatch(fetchApiGroups(site));
    }

    // FOR SITES DROPDOWN API
    async function fetchSiteRequest() {
        showLoader("fetchSiteRequest");
        props.dispatch(fetchSites());
    }

    // TO UPDATE SITE DROPDOWN 
    useEffect(() => {
        if (props.siteList.data) {
            // const transformedSites = props.siteList.data.sites.map(siteValue => {
            //     const matchingOption = availableSiteOptions.find(option => option.value === siteValue);
            //     return matchingOption ? { name: matchingOption.name, value: matchingOption.value } : null;
            // }).filter(Boolean); 
        
            setSites(props.siteList.data.sites);
            setSelectedSite(props.siteList.data.sites[0] || "");

            hideLoader("fetchSiteRequest");
            fetchRequest(props.siteList.data.sites[0]);
        }
    }, [props.siteList])

    // TO UPDATE TABLE DATA IF APIGROUP LIST CHANGES
    useEffect(() => {
        if (props.apiGroupList.data) {
            setRequestResponse(props.apiGroupList.data);
        }
    }, [props.apiGroupList])

    // TO UPDATE FILTERED DATA IF REQUEST RESPONSE CHANGES
    useEffect(() => {
        if (Object.keys(requestResponse).length > 0) {
            console.log(selectedStatus, selectedStatus == "");
            if(selectedStatus == ""){
                setFilteredData(requestResponse);
            } else {
                updateTableOnStatusChange(selectedStatus);
            }
        }
        hideLoader("fetchRequest");
    }, [requestResponse]) 

    // TO HANDLE ERROR AND RESPONSE OF APPROVE DENY AND DELETE
    useEffect(() => {
        if (props.response?.data) {
            hideLoader("failed");
            const toastMessage = props.response?.data?.messages?.[0] || props.response?.data?.message || 'An unexpected error occurred';
    
            if (props.response.data?.status == "SUCCESS") {
                showToast({
                    title: 'Operation Success',
                    bg: 'success',
                    message: toastMessage,
                });
                fetchRequest(selectedSite);
            } else {
                showToast({
                    title: 'Operation Failed',
                    bg: 'danger',
                    message: toastMessage,
                });
            }

            return;
        }

        if (props.errorResponse?.status == false) {
            hideLoader("failed");
            showToast({
                title: 'Operation Failed',
                bg: 'danger',
                message: props.errorResponse?.data || 'An unexpected error occurred',
            });
        }
    
    }, [props.errorResponse, props.response])


    // FOR FILTER BASED ON STATUS
    const selectStatus = useRef();
    useEffect(() => {
        const select = selectStatus.current;
        if (!select) {
            return false; 
        }
        select.addEventListener('hbr-change', onStatusChange);
        return () => {
            select.removeEventListener('hbr-change', onStatusChange);
        }; 
    });

    const onStatusChange = useCallback((e) => {
        setSelectedStatus(e.target.value);
        updateTableOnStatusChange(e.target.value);
    });

    const updateTableOnStatusChange = (value) => {
        let updatedData = {};
        if(value =="") {
            setFilteredData(requestResponse);
        } else {
            updatedData = {
                ...requestResponse,
                groups: requestResponse.groups.map((item) => ({
                    ...item,
                    apis: item.apis.filter((api) => 
                        api.status.toLowerCase() === value.toLowerCase()
                    )
                }))
            };
            setFilteredData(updatedData);
        }
    };

    // FOR FILTER BASED ON SITES
    const selectSite = useRef();
    useEffect(() => {
        const select = selectSite.current;
        if (!select) {
            return false; 
        }
        select.addEventListener('hbr-change', onSiteChange);
        return () => {
            select.removeEventListener('hbr-change', onSiteChange);
        }; 
    });

    const onSiteChange = useCallback((e) => {
        setSelectedSite(e.target.value);
        setSelectedStatus("");
        selectStatus.current.value = "";
        fetchRequest(e.target.value);
    });

    // FOR EXPANDING COLLAPSING ROW - API GROUP
    const toggleRow = (index, groupName) => {
        setExpandedRow(expandedRow === index ? null : index);
        setSelectedApiGroup(groupName);
    };

    // FOR ACTION ITEMS ICONS
    const getActionBtns = (api) => {
        let statusCase = api.status.toLowerCase();
        let retVal = "";
        switch (statusCase) {
        case 'pending':
            retVal = (
                <div>
                    <i className="atm-icon me-3 check-outline" onClick={() => clickPop("approve", api)}></i>
                    <i className="atm-icon me-3 exit-outline" onClick={() => clickPop("deny", api)}></i>
                </div>);
        break;
        case 'approved':
            retVal = (<div>
                        <i className="atm-icon me-3 exit-outline" onClick={() => clickPop("deny", api)}></i>
                    </div>);
        break;
        case 'denied':
            retVal = (<div>
                        <i className="atm-icon me-3 check-outline" onClick={() => clickPop("approve", api)}></i>
                        <i className="atm-icon me-3 delete" onClick={() => clickPop("remove", api)} />
                    </div>);
        break;
        default:
        break;
    }
        return (
            <div className="action">
                    {retVal}
            </div>
        )
    }
    
    // FUNCTION TO GET EXECUTED WHEN CLICKING ANY ACTION ICONS
    const clickPop = (type,api) => {
        const selectedApi = {
            "type":type,
            "apiDetailsId": api.apiDetailsId,
            "apiId":api.apiId, 
            "domain": api.domain, 
            "site": selectedSite.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '), 
            "apiGroup": selectedApiGroup,
            "status": type,
            "requesterName": api.requesterName,
            "requesterEmail": api.requesterEmail
        };
        setSelectedRequest(selectedApi);
        setIsModalOpen(true);
    };

    // TO GET EXECUTED WHEN CLICKING ON SUBMIT IN APPROVE, DENY AND DELETE POPUP
    const handleRequest = (reason) => {
        closeModal();
        if (selectedRequest.type === 'remove') {
          handleDelete();
        } else if (selectedRequest.type === 'approve') {
          handleApprove()
        } else {
          handleDeny(reason);
        }
    }

    // TO CLOSE APPROVE DENY DELETE POPUP
    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedRequest(null);
    };

    // TO MAKE API CALL FOR DELETE API REQ
    const handleDelete = async () => {
        showLoader("handleDelete");
        props.dispatch(deleteRequest(selectedRequest));
    };
    
    // TO MAKE API FOR APPROVE API REQ
    const handleApprove = async () => {
        showLoader("handleApprove");
        props.dispatch(approveRequest(selectedRequest, "APPROVED"));
    };
    
    // TO MAKE API FOR DENY API REQ
    const handleDeny = async (reason) => {
        showLoader("handleDeny");
        props.dispatch(denyRequest(selectedRequest, "DENIED", reason));
    };

    return (
        <div id="pubhub-widgets" className="pubhub-site-container">
            {isModalOpen && 
                <ActionModals show={isModalOpen} type={selectedRequest?.type} onClose={() => closeModal()} onSubmit={(reason)=> handleRequest(reason)}/>
            }
            <div className="mt-4 mx-5 request-table">
                <h4 className='text-primary mb-4'>Sites Management</h4>
                <div className='d-flex justify-content-between'>
                    <div className='d-flex align-items-center'>
                        <span className='me-3'>Sites:</span>
                        <span className='select-box-width'>
                            <hbr-select ref={selectSite} value={selectedSite}>
                                {sites.map((item, index) => (
                                    // <hbr-option key={index} value={item.value}>{item.name}</hbr-option>
                                    <hbr-option key={index} value={item}>{item}</hbr-option>
                                ))}
                            </hbr-select>
                        </span>
                    </div>
                    <div className='d-flex align-items-center'>
                        <span className='me-3'>Filter by Status:</span>
                        <span className='select-box-width'>
                            <hbr-select ref={selectStatus}>
                                <hbr-option value="">All</hbr-option>
                                <hbr-option value="Pending">Pending</hbr-option>
                                <hbr-option value="Approved">Approved</hbr-option>
                                <hbr-option value="Denied">Denied</hbr-option>
                            </hbr-select>
                        </span>
                    </div>
                </div>
                <table className="table mt-4 iap-table">
                    <thead>
                        <tr>
                            <th className='arrow-head'></th>
                            <th>API Name</th>
                            <th>Requester Name</th>
                            <th>Requester Email</th>
                            <th>Created Date</th>
                            <th>Approved By</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredData.groups && filteredData.groups.length > 0 && filteredData.groups.map((group, index) => (
                            <React.Fragment key={group.name}>
                            <tr key={index}>
                                <td className='arrow-head'> 
                                <span onClick={() => toggleRow(index, group.name)}>
                                    <IconChevron  isopen={expandedRow === index} />
                                </span>
                                
                                </td>
                                <td className='api-name'>{group.name}</td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            {expandedRow === index && group.apis.length > 0 && group.apis.map((api, ind) => (
                                <tr key={ind}>
                                    <td></td>
                                    <td>{api.apiName}
                                        <a href={api.reviewHyperLink} target="_blank" rel="noopener noreferrer">
                                            <i className="atm-icon jump-out apiLink"/>
                                        </a>
                                    </td>
                                    <td className='app-name'>{api.requesterName}</td>
                                    <td>{api.requesterEmail}</td>
                                    <td>{api.createdDate}</td>
                                    <td>{api.approver}</td>
                                    {api.status.toLowerCase() == "denied" && 
                                        <td>
                                            <hbr-tooltip size="small" content={api.reason} trigger="hover" placement="top" className="atm-tooltip--small">
                                                <RequestStatusBadge status={api.status} />
                                            </hbr-tooltip>
                                        </td>
                                    }
                                    {api.status.toLowerCase() != "denied" && 
                                        <td>
                                            <RequestStatusBadge status={api.status} />
                                        </td>
                                    }
                                    <td>
                                        {getActionBtns(api)}
                                    </td>
                                </tr>
                            ))}
                            {expandedRow === index && group.apis.length == 0 && 
                                <tr>
                                    <td><p className='text-center mb-0'>No Records found</p></td>
                                </tr>
                            }
                            </React.Fragment>
                        ))}
                        {filteredData.groups && filteredData.groups.length == 0 && (
                        <tr>
                            <td colSpan="7">
                                <div className='text-center empty-state'>
                                    <img
                                        src="https://www.cisco.com/c/dam/cdc/ui/atm/1-5-0/images/illustrations/empty-state/no-results-light-large.svg"
                                        alt="Empty state illustration"
                                        width="240px"
                                        height="160px"
                                            />
                                    <p className='text-center mb-0'>No Records found</p>
                                </div>
                            </td>
                        </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );

}

const mapStateToProps = (state) => {
    return {
        loader: state.sites.isLoading,
        errorResponse: state.sites.errorResponse,
        siteList: state.sites.siteList,
        apiGroupList: state.sites.apiGroupList,
        response: state.sites.response
    }
}

export default connect(mapStateToProps)(MySites);
